var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-map"},[_c('v-chart',{ref:"mapChart",attrs:{"options":_vm.mergedConfig,"initOptions":_vm.initOptions,"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }